import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";
import { defaultField } from "helpers/row-logic-helper";

import {
  shouldShowPaymentDay
  , shouldShowPaymentDayAdjust
  , shouldShowCalculationDay
  , shouldShowCalculationDayAdjust
  , shouldShowRounding
  , shouldShowResetDay
  , shouldShowResetDayAdjust
  , shouldShowResetDayLookback
  , shouldShowLei
  , shouldShowCollateral
  , shouldShowGuaranty
  , shouldShowCollateralAssignment
  , shouldShowLegalOpinion
  , shouldShowLoanTag
} from "./section-general-information-rows-logic";

export const rows = {
  title: {
    label: "General Information",
    isTitle: true
  },
  paymentDay: {
    isVisible: data => shouldShowPaymentDay(data),
    label: "Payment Day",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "paymentDay",
        variant: "filled",
        decimals: 0
      }
    ]
  },
  paymentDayAdjust: {
    label: "Payment Adjustment",
    isVisible: data => shouldShowPaymentDayAdjust(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "paymentDayAdjust",
        name: "paymentDayAdjustId",
        variant: "filled",
        options: [
          { id: "9ad1d79e-7d75-11e9-9c8e-0242ac140002", name: "Following" },
          { id: "9ad1d7bf-7d75-11e9-9c8e-0242ac140002", name: "Modified Following" },
          { id: "9ad1d7e3-7d75-11e9-9c8e-0242ac140002", name: "Preceding" },
          { id: "9ad1d807-7d75-11e9-9c8e-0242ac140002", name: "Modified Preceding" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  calculationDay: {
    isVisible: data => shouldShowCalculationDay(data),
    label: "Calculation Day",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "calculationDay",
        variant: "filled",
        decimals: 0
      }
    ]
  },
  calculationDayAdjust: {
    isVisible: data => shouldShowCalculationDayAdjust(data),
    label: "Calculation Adjustment",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "calculationDayAdjust",
        name: "calculationDayAdjustId",
        variant: "filled",
        options: [
          { id: "9ad1d853-7d75-11e9-9c8e-0242ac140002", name: "Following" },
          { id: "9ad1d87c-7d75-11e9-9c8e-0242ac140002", name: "Modified Following" },
          { id: "9ad1d8a6-7d75-11e9-9c8e-0242ac140002", name: "Preceding" },
          { id: "9ad1d8d2-7d75-11e9-9c8e-0242ac140002", name: "Modified Preceding" },
          { id: "9ad1d8ff-7d75-11e9-9c8e-0242ac140002", name: "Unadjusted" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  rounding: {
    isVisible: data => shouldShowRounding(data),
    label: "Calculation Rounding",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "rounding",
        name: "roundingId",
        variant: "filled",
        options: [
          { id: "1e2bd52a-766e-11e9-87b9-0242ac120002", name: "1/100th (2 decimals)" },
          { id: "2dc24865-766e-11e9-87b9-0242ac120002", name: "1/1,000th (3 decimals)" },
          { id: "38f5d966-766c-11e9-87b9-0242ac120002", name: "No Rounding" },
          { id: "3a62b842-766e-11e9-87b9-0242ac120002", name: "1/10,000th (4 decimals)" },
          { id: "4a92ede9-766e-11e9-87b9-0242ac120002", name: "1/8th" },
          { id: "5a08327b-766e-11e9-87b9-0242ac120002", name: "1/16th" },
          { id: "663f1525-766e-11e9-87b9-0242ac120002", name: "1/32nd" },
          { id: "765f2177-766e-11e9-87b9-0242ac120002", name: "1/64th" },
          { id: "c0059aaf-8897-11e9-93c5-00155ddd690a", name: "1/10th (1 decimal)" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  resetDay: {
    isVisible: data => shouldShowResetDay(data),
    label: "Reset Day",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "resetDay",
        variant: "filled",
        decimals: 0
      }
    ]
  },
  resetDayAdjust: {
    isVisible: data => shouldShowResetDayAdjust(data),
    label: "Reset Adjustment",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "resetDayAdjust",
        name: "resetDayAdjustId",
        variant: "filled",
        options: [
          { id: "9ad1d95f-7d75-11e9-9c8e-0242ac140002", name: "Following" },
          { id: "9ad1d991-7d75-11e9-9c8e-0242ac140002", name: "Modified Following" },
          { id: "9ad1d9c5-7d75-11e9-9c8e-0242ac140002", name: "Preceding" },
          { id: "9ad1d9fa-7d75-11e9-9c8e-0242ac140002", name: "Modified Preceding" },
          { id: "9ad1da31-7d75-11e9-9c8e-0242ac140002", name: "Unadjusted" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  resetDayLookback: {
    isVisible: data => shouldShowResetDayLookback(data),
    label: "Lookback Days",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "resetDayLookback",
        variant: "filled",
        decimals: 0
      }
    ]
  },
  daycount: {
    label: "Daycount Ratio",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "daycount",
        name: "daycountId",
        variant: "filled",
        options: [
          { id: "27c630c3-766f-11e9-87b9-0242ac120002", name: "Act/365" },
          { id: "41a7e0bb-fd1e-42b4-8c50-c5e44dc81372", name: "30/360" },
          { id: "6ed392ab-2f95-4186-a1ab-e3e4019051ed", name: "Act/Act" },
          { id: "fb692b8f-766e-11e9-87b9-0242ac120002", name: "Act/360" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  lei: {
    isVisible: data => shouldShowLei(data),
    label: "LEI",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "lei",
        variant: "filled",
        decimals: 0
      }
    ]
  },
  collateral: {
    isVisible: data => shouldShowCollateral(data),
    label: "Collateral",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "collateral",
        name: "collateralId",
        variant: "filled",
        options: [
          { id: "9ad1d729-7d75-11e9-9c8e-0242ac140002", name: "Property" },
          { id: "9ad1d745-7d75-11e9-9c8e-0242ac140002", name: "Cash" },
          { id: "9ad1d761-7d75-11e9-9c8e-0242ac140002", name: "Guaranty" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  guaranty: {
    isVisible: data => shouldShowGuaranty(data),
    label: "Guaranty",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "guaranty",
        label: "Yes",
        altlabel: "No"
      }
    ]
  },
  collateralAssignment: {
    isVisible: data => shouldShowCollateralAssignment(data),
    label: "Collateral Assignment",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "collateralAssignment",
        label: "Yes",
        altlabel: "No"
      }
    ]
  },
  legalOpinion: {
    isVisible: data => shouldShowLegalOpinion(data),
    label: "Legal Opinion",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "legalOpinion",
        label: "Yes",
        altlabel: "No"
      }
    ]
  },
  taggedTo: {
    label: "Tagged to",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "taggedTo",
        label: "Deal",
        altlabel: "Loan"
      }
    ]
  },
  loanId: {
    label: "Associated Loan",
    isVisible: data => shouldShowLoanTag(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "loanId",
        name: "loanId",
        parentId: "dealLoans",
        variant: "filled",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        },
        style: { width: "60%" }
      }
    ]
  },
  isLenderRequired: {
    label: "Required Hedge",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "isLenderRequired",
        label: "Yes",
        altlabel: "No"
      }
    ]
  }
};

